// # Payment Shares Preview Component
import React from 'react';
import { FaDollarSign } from 'react-icons/fa';
import './pay_share.css';

// # Format number with commas for thousands
const formatNumber = (num) => {
  if (!num) return '0.00';
  return Number(num).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// # Get display name for recipient
const getRecipientDisplayName = (recipientId) => {
  if (recipientId === 'budget') return 'Budget Allocation';
  
  // # Team members configuration - imported from the original file
  const teamMembers = [
    { id: 'ahmed_hadidy', name: 'Ahmed Elhadidy', email: 'ahmed.hadidyy@gmail.com' },
    { id: 'nabil_mostafa', name: 'Nabil Mostafa', email: 'nabilmostafa14941@gmail.com' },
    { id: 'ahmed_ayman', name: 'Ahmed Ayman', email: 'ahmed.aymaan7474@gmail.com' },
    { id: 'ahmed_hussein', name: 'Ahmed Hussein', email: 'Ahmedsehs77@gmail.com' },
    { id: 'hossam_gomaa', name: 'Hossam Gomaa', email: 'hossamgomaa487@gmail.com' }
  ];
  
  const member = teamMembers.find(m => m.id === recipientId);
  return member ? member.name : recipientId;
};

// # Dividend Preview Table Component
const PayShare = ({ shares, budgetDvdAmount, budgetDvdPercent, egpTotal }) => {
  // # Calculate net amount
  const netAmount = egpTotal - (budgetDvdAmount || 0);

  return (
    <div className="pay_share_dividend-preview">
      <div className="pay_share_section-header">
        <FaDollarSign />
        <h2>Payment Shares Preview</h2>
      </div>
      
      <table className="pay_share_dividend-table">
        <thead>
          <tr>
            <th>Recipient</th>
            <th>Percentage</th>
            <th>Net Amount (EGP)</th>
            <th>Total Share (EGP)<br/><small>(No Budget)</small></th>
          </tr>
        </thead>
        <tbody>
          {budgetDvdAmount > 0 && (
            <tr className="pay_share_budget-row">
              <td>Budget Allocation</td>
              <td>{budgetDvdPercent}% (of total)</td>
              <td>E£ {formatNumber(budgetDvdAmount)}</td>
              <td>E£ 0.00</td>
            </tr>
          )}
          {shares && Object.entries(shares).map(([recipient, data]) => (
            <tr key={recipient}>
              <td>{getRecipientDisplayName(recipient)}</td>
              <td>{data.percentage_of_net}% (of net)</td>
              <td>E£ {formatNumber(data.net_share_egp)}</td>
              <td>E£ {formatNumber(data.total_share_egp)}</td>
            </tr>
          ))}
          <tr className="pay_share_net-row">
            <td colSpan="2">Net Amount (after budget)</td>
            <td>E£ {formatNumber(netAmount)}</td>
            <td>-</td>
          </tr>
          <tr className="pay_share_total-row">
            <td colSpan="2">Total Amount</td>
            <td>E£ {formatNumber(egpTotal)}</td>
            <td>E£ {formatNumber(egpTotal)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default PayShare;
